import request from '@/utils/request'

export default {
  // 添加角色
  postJobAdd(data = {}) {
    return request({
      url: `/emi/role/add`,
      method: 'post',
      data
    })
  },
  // 角色列表
  postJobList(data = {}) {
    return request({
      url: `/emi/role/list`,
      method: 'post',
      data
    })
  },
  // 删除角色
  postJobDelete(data = {}) {
    return request({
      url: `/emi/role/deleted`,
      method: 'post',
      data
    })
  },
  // 获取角色详情
  postJobDetail(data = {}) {
    return request({
      url: `/emi/role/info`,
      method: 'post',
      data
    })
  },
  // 编辑角色
  postJobUpdate(data = {}) {
    return request({
      url: `/emi/role/update`,
      method: 'post',
      data
    })
  }
}
